import React from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import logo from '../../images/logo-v.svg'

const FooterContainer = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`
const FooterWraper = styled.div`
  background-color: ${({ theme }) => theme.colors.footer};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .container {
    width: ${(props) => props.theme.containerWidth};
    height: 320px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .img {
      width: 109px;
      height: 118px;
    }
    .wrapper {
      display: flex;
      flex-grow: 2;
      justify-content: space-around;
      .item {
        color: ${({ theme }) => theme.colors.font};
        a {
          color: ${({ theme }) => theme.colors.font};
          &:hover {
            color: #fff;
          }
        }
        h3 {
          font-size: 1.6rem;
          padding-bottom: 5px;
          color: #fff;
        }
        p {
          margin-top: 15px;
          font-size: 1.4rem;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .container {
      width: 100%;
      padding: 30px 0;
      height: auto;
      justify-content: center;
      flex-direction: column;
      .img {
        width: 50%;
        height: auto;
      }
      .wrapper {
        justify-content: center;
        flex-direction: column;
        .item {
          margin-top: 30px;
        }
      }
    }
  }
`
const CopyrightWraper = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  .container {
    height: 115px;
    width: ${(props) => props.theme.containerWidth};
    display: flex;
    align-items: center;
    justify-content: space-between;
    div {
      display: flex;
      height: 100%;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      p {
        color: ${({ theme }) => theme.colors.footer};
        width: 100%;
      }
      p + p {
        margin-top: 10px;
      }
    }
    .left {
      p {
        text-align: left;
      }
    }
    .right {
      p {
        text-align: right;
      }
    }
  }
  @media (max-width: 768px) {
    .container {
      width: 100%;
      height: auto;
      padding: 30px;
      flex-direction: column;
      div {
        width: 100%;
      }
      .right p {
        margin-top: 10px;
        text-align: left;
      }
    }
  }
`
const Footer = () => {
  const { strapiHome } = useStaticQuery(graphql`
    {
      strapiHome {
        contactAddress
        contactEmail
        contactPhone
        contactZipcode
        enterpriseSite {
          id
          title
          url
        }
        friendlyLink {
          id
          title
          url
        }
        urlOA
        urlMail
      }
    }
  `)
  const {
    contactAddress,
    contactEmail,
    contactPhone,
    contactZipcode,
    enterpriseSite,
    friendlyLink
  } = strapiHome
  return (
    <FooterContainer>
      <FooterWraper>
        <div className="container">
          <img
            className="img"
            src={logo}
            alt="锦江城市服务"
            data-sal="slide-right"
            data-sal-delay="300"
            data-sal-easing="ease"
          />
          <div className="wrapper">
            <div
              className="item"
              data-sal="slide-left"
              data-sal-delay="300"
              data-sal-easing="ease"
            >
              <h3>联系我们</h3>
              <p>地址：{contactAddress}</p>
              <p>邮编：{contactZipcode}</p>
              <p>电话：{contactPhone}</p>
              <p>邮箱：{contactEmail}</p>
            </div>
            <div
              className="item"
              data-sal="slide-left"
              data-sal-delay="300"
              data-sal-easing="ease"
            >
              <h3>企业站点</h3>
              {enterpriseSite.map((item) => (
                <p key={item.id}>
                  <a href={item.url} target="_blank">
                    {item.title}
                  </a>
                </p>
              ))}
            </div>
            <div
              className="item"
              data-sal="slide-left"
              data-sal-delay="300"
              data-sal-easing="ease"
            >
              <h3>友情链接</h3>
              {friendlyLink.map((item) => (
                <p key={item.id}>
                  <a href={item.url} target="_blank">
                    {item.title}
                  </a>
                </p>
              ))}
            </div>
          </div>
        </div>
      </FooterWraper>
      <CopyrightWraper>
        <div className="container">
          <div
            className="left"
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <p>
              Copyright©{new Date().getFullYear()} 上海锦江城市服务有限公司，All
              Rights Reserved
            </p>
            <p>
              备案号：
              <a href="https://beian.miit.gov.cn" target={'_blank'}>
                沪ICP备2021035103号
              </a>
            </p>
          </div>
          <div
            className="right"
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <p>技术支持：上海格萝卜网络科技有限公司</p>
            <p>建议使用Chrome、Firefox、Edge等现代浏览器浏览</p>
          </div>
        </div>
      </CopyrightWraper>
    </FooterContainer>
  )
}

export default Footer
